import script from "./FormEditarPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEditarPerfil.vue?vue&type=script&setup=true&lang=js"

import "./FormEditarPerfil.vue?vue&type=style&index=0&id=774d05bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774d05bb"]])

export default __exports__